import {ConferencingActions} from './ConferencingActions';

export const stores = [
  ConferencingActions
];



// WEBPACK FOOTER //
// ./src/shared/stores/conferencing/index.js